"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AutoPromiseManagementService = function () {
    function AutoPromiseManagementService($http, appConfig) {
        "ngInject";

        (0, _classCallCheck3.default)(this, AutoPromiseManagementService);
        this.$http = $http;
        this.appConfig = appConfig;
    }

    (0, _createClass3.default)(AutoPromiseManagementService, [{
        key: "add",
        value: function add(entityId, autoPromise) {
            return this.$http.post(this.appConfig.apiServiceBaseUri + ("api/autopromise/add/" + entityId), autoPromise);
        }
    }, {
        key: "edit",
        value: function edit(entityId, autoPromise) {
            return this.$http.post(this.appConfig.apiServiceBaseUri + ("api/autopromise/edit/" + entityId), autoPromise);
        }
    }, {
        key: "list",
        value: function list(entityId) {
            return this.$http.get(this.appConfig.apiServiceBaseUri + ("api/autopromise/list/" + entityId));
        }
    }, {
        key: "remove",
        value: function remove(entityId, autoPromiseId) {
            return this.$http.get(this.appConfig.apiServiceBaseUri + ("api/autopromise/remove/" + entityId + "/" + autoPromiseId));
        }
    }]);
    return AutoPromiseManagementService;
}();

exports.default = AutoPromiseManagementService;


// WEBPACK FOOTER //
// ./client/app/components/admin/autoPromiseManagement/autoPromiseManagement.service.js